module.exports = __webpack_public_path__ + "img/dialogRight.dead8117.png";